import React from "react";
import { Shield, CircleCheckBig, Sparkles, Clock, House } from "lucide-react";
import { whyChooseData } from "../../data/mockData";

const iconMap = {
  Shield,
  CircleCheckBig,
  Sparkles,
  Clock,
  House,
};

const WhyChooseSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            {whyChooseData.title}
          </h3>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            {whyChooseData.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {whyChooseData.features.map((feature) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                className="rounded-xl bg-white shadow border-2 border-sky-100 hover:border-sky-300 transition-all duration-300 hover:shadow-lg"
              >
                <div className="p-6 space-y-4">
                  <div className="w-14 h-14 bg-sky-100 rounded-lg flex items-center justify-center">
                    {IconComponent && (
                      <IconComponent className="w-7 h-7 text-sky-600" />
                    )}
                  </div>
                  <h4 className="text-xl font-bold text-slate-900">
                    {feature.title}
                  </h4>
                  <p className="text-slate-600">{feature.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
